import { FC, ReactNode } from 'react';

interface InternalSectionHeaderProps {
    title: string;
    description?: string;
    icon?: ReactNode;
}

export const InternalSectionHeader: FC<InternalSectionHeaderProps> = ({ title, description, icon }) => (
    <div className="mb-4">
        <div className="flex items-center gap-2 mb-1">
            {icon}
            <h2 className="text-[12px] font-bold text-slate-800 uppercase tracking-wider">{title}</h2>
        </div>
        {description && (
            <p className="text-[11px] text-slate-500 font-medium pl-[28px]">{description}</p>
        )}
    </div>
);
